import { createContext, useContext } from "react";

import type { CurrentUser } from "./keycloak";

export const UserContext = createContext<CurrentUser | null>(null);

export function useUser(): CurrentUser {
  const u = useContext(UserContext);
  if (!u) throw new Error("UserContext nije postavljen");
  return u;
}

export function useCan() {
  const u = useUser();
  return (perm: string) => u.permissions.includes(perm);
}
